<template>
  <el-select @change="handleChange" popper-class="cust-select-poper" v-model="accessType"  style="width: 100%">
        <el-option :label="$t('ALL_OPTION')" value="ALL" >
                <p @click.stop="confirmValue">
                    <el-radio class="mr_10 label-hidden" label="ALL" v-model="accessType" ></el-radio>
                    <span class="option-label">{{$t('ALL_OPTION')}}</span>
                </p>
            <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc" @click.stop="confirmValue">
               User has access to all entities content across all tiles.
                </p>
                <p class="mr_25 desc"></p>
            </template>
            <template v-else>
                <p class="mr_25 desc" @click.stop="confirmValue">
                    用户可以访问所有实体及所有功能版块中的内容。
                </p>
            </template>
        </el-option>
        <el-option :label="$t('SPECIFIC_OPTION')"  value="SPECIFIC">
            <p >
                <el-radio class="mr_10 label-hidden" label="SPECIFIC"  v-model="accessType"></el-radio>
                <span class="option-label">{{$t('SPECIFIC_OPTION')}}</span>
            </p>
            <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc">
                    User has access to all tiles content based on the
                </p >
                <p class="mr_25 desc">authorised client entities.</p>
            </template>
            <template v-else>
                <p class="mr_25 desc" >
                    用户可以访问所授权实体在各功能版块中的内容。  
                </p>
            </template>
        </el-option>
        <el-option :label="$t('TAILORED_OPTION')"  value="TAILORED">
            <p >
                <el-radio class="mr_10 label-hidden" label="TAILORED"  v-model="accessType"></el-radio>
                <span class="option-label">{{$t('TAILORED_OPTION')}}</span>
            </p>
            <template v-if="$i18n.locale === 'en'">
            <p class="mr_25 desc">
                User has access to the assigned role(s),which is  
            </p >
            <p class="mr_25 desc">based on the tailored access to specific titles and</p>
            <p class="mr_25 desc">authorised client entities.</p>
            </template>
             <template v-else>
                <p class="mr_25 desc" >
                    用户可以访问所分配“角色”中配置的权限内容。  
                </p>
            </template>
        </el-option>
    </el-select>
</template>

<script>
export default {
    props:{
        initData:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            accessType:"",
        }
    },
    watch:{
       initData:{
            handler:function(val){
                this.accessType =val;
            },
            immediate:true
       } 
    },
    methods:{
        confirmValue(){
                 this.$confirm(this.$t('tailored_tip'),this.$t('tailored_warning'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning',
                    cancelButtonClass: 'cancel-btn',
                    confirmButtonClass: 'wl-green'
                }).then(() => {
                    this.accessType = "ALL";
                    this.$emit("change", this.accessType)
                })
        },
        handleChange(){
            this.$emit("change", this.accessType)
        }
    }
}
</script>

<style scoped>
    .mr_10{
    margin-right:10px;
    }
    .mr_25{
        margin-left:25px;
    }
    .desc{
        color:#636363;
        font-weight:400;
    }
    ::v-deep .label-hidden .el-radio__label{
        display: none;
    }
</style>